import { useEffect, useState } from 'react';

import { ProfileMenuLinks } from 'src/utils/constants/RouterConstants';
import { UserTypes } from 'src/utils/constants/stringConstants';
import { FeatureFlagConstants } from 'src/utils/constants/utilConstants';
import { getFeatureFlagConfig } from 'src/utils/RemoteConfig';

import { useAppStore } from 'src/hooks/useAppStore';
import {
  MIXPANEL_CROSS,
  MIXPANEL_PROFILE
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import { timeEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import HamburgerMenuGroup from '../hamburgerMenu/hamburgerMenuGroup/HamburgerMenuGroup';
import { HamburgerMenuFooterTitle } from '../hamburgerMenu/HamburgerMenuStyle';
import {
  getProfileMenuList,
  profileMenuMixpanelEvent
} from './ProfileMenuHelper';
import {
  container,
  ProfileMenuContainer,
  ProfileMenuFooter,
  ProfileMenuHeader,
  UserProfile,
  ViewAllButton
} from './ProfileMenuStyle';

export const profileMenuHeader = () => {
  profileMenuMixpanelEvent(MIXPANEL_PROFILE);
  timeEvent();
  window.location.href = ProfileMenuLinks.MY_PROFILE;
};

type ProfileMenuProps = {
  show: boolean;
  handleProfileMenuClick: () => void;
};

const ProfileMenu = ({ show, handleProfileMenuClick }: ProfileMenuProps) => {
  const {
    initialLaunchData,
    translations,
    usersData,
    isUserLoggedIn,
    remoteConfig
  } = useAppStore();
  const HeaderStrings = translations?.common;
  const { MYACCOUNT, VERSION } = HeaderStrings || {};
  const { payload, enabled } = getFeatureFlagConfig(
    remoteConfig,
    FeatureFlagConstants.CONFIG_SPORTS
  );
  const predictWinFlag = enabled ? payload.predict_win_flag : false;

  const profileMenuList = initialLaunchData
    ? getProfileMenuList(
        HeaderStrings,
        initialLaunchData,
        isUserLoggedIn,
        predictWinFlag
      )
    : [];

  const userName =
    (usersData?.first_name !== ' ' && usersData?.first_name) || UserTypes.GUEST;

  const menuData = [
    {
      name: MYACCOUNT,
      show: true,
      items: profileMenuList.filter((item) => {
        if (item) return item;
      })
    }
  ];

  const [menuState, setMenuState] = useState(menuData);

  useEffect(() => {
    if (show) {
      profileMenuMixpanelEvent(MIXPANEL_PROFILE);
    } else {
      profileMenuMixpanelEvent(MIXPANEL_CROSS);
    }
  }, [show]);

  const handleMenuGroupCollapse = (name: string) => {
    setMenuState((prevState) => {
      return prevState.map((element) => {
        if (element.name === name) {
          element.show = !element.show;
          return { ...element, show: !element.show };
        }
        return element;
      });
    });
  };
  return (
    <div css={container}>
      <ProfileMenuContainer>
        <ProfileMenuHeader onClick={profileMenuHeader}>
          <UserProfile />
          <div>{userName}</div>
          <ViewAllButton />
        </ProfileMenuHeader>
        {menuData.map((menuGroup) => {
          if (menuGroup.items)
            return (
              <HamburgerMenuGroup
                key={menuGroup.name}
                show={menuGroup.show}
                name={menuGroup.name}
                items={menuGroup.items}
                onClick={handleMenuGroupCollapse}
                hamburgerMenuCLickHandler={handleProfileMenuClick}
              />
            );
        })}
        <ProfileMenuFooter>
          <span css={HamburgerMenuFooterTitle}>
            {VERSION} {process.env.APP_VERSION}
          </span>
        </ProfileMenuFooter>
      </ProfileMenuContainer>
    </div>
  );
};

export default ProfileMenu;
